import React, { useEffect } from "react";
import { useParams } from "react-router";
import { Buffer } from "buffer";
import { UpdatePasswordSchema } from "../../Schemas/user/update_password_schema";
import Footer from "../../Components/Footer/footer";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import { Form, Formik } from "formik";
import { useState } from "react";
import CustomInput from "../../CustomComponent/custom_input";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useNavigate } from "react-router-dom";
const UpdatePassword = () => {
  //   const user = useSelector((store) => store.login.user);
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const navigate = useNavigate();

  function decodeEmail(encoded) {
    return Buffer.from(encoded, "base64").toString("utf8");
  }

  const { email, time } = useParams();
  const timestamp = time;
  const demail = decodeEmail(email);

  useEffect(() => {
    if (timestamp) {
      const currentTime = Date.now();
      const fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
      if (currentTime - timestamp > fiveMinutes) {
        navigate("/expired-link");
      }
    }
  }, [time]);

  const handelSubmit = (values, actions) => {
    values = { ...values, email: demail };
    setLoading(true);
    performRequest("PATCH", "/password/change-password/", values)
      .then((res) => {
        if (res.status === 200) {
          navigate("/account-login");
          Toast("success", "Password reset successfully!");
        } else {
          Toast("error", "Error while password reset!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="page page-wrapper">
      <div className="container-xl">
        <div className="page-center" style={{ minHeight: "85vh" }}>
          <div className="container container-normal ">
            <div className="row">
              <div className="col-lg mt-7">
                <div className="container-tight">
                  <div className="text-center mb-4">
                    <span>
                      {/* <img
                    className="navbar-brand-image"
                    src="https://www.kryzen.com/wp-content/uploads/2022/02/kryzen-logo-1.png"
                    alt="Kryzen"
                    style={{
                      width: "110px",
                      height: "50px",
                    }}
                  /> */}
                      <h1 className="fs-large m-0 p-0">
                        <span className="text-primary">α</span>lpha
                      </h1>
                      <p className="fs-5 ps-6 m-0 text-success">by KRYZEN</p>
                    </span>
                  </div>
                  <div className="card card-md">
                    <div className="card-body">
                      <h2 className="h2 text-center mb-4">Update Password</h2>

                      <Formik
                        initialValues={{ password: "", confirmPassword: "" }}
                        validationSchema={UpdatePasswordSchema}
                        onSubmit={handelSubmit}
                      >
                        {(props) => (
                          <Form>
                            <div className="card-body">
                              <p className="text-muted mb-4">
                                Please enter and confirm your new password.
                              </p>
                              <div className="mb-3">
                                <label className="form-label">
                                  New Password
                                </label>
                                <div className="input-group input-group-flat">
                                  <CustomInput
                                    name="password"
                                    autoComplete="off"
                                    placeholder="Enter password"
                                    type={showPass ? "text" : "password"}
                                  />

                                  <span className="input-group-text">
                                    <span
                                      onClick={() => setShowPass(!showPass)}
                                      className="link-secondary"
                                      title="Show password"
                                      role="button"
                                      data-bs-toggle="tooltip"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="icon"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <path
                                          stroke="none"
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                        />
                                        <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                        <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                                      </svg>
                                    </span>
                                  </span>
                                </div>
                                {props.touched.password &&
                                  props.errors.password && (
                                    <p className="text-danger">
                                      {props.errors.password}
                                    </p>
                                  )}
                              </div>
                              <div className="mb-3">
                                <label className="form-label">
                                  Confirm New Password
                                </label>
                                <div className="input-group input-group-flat">
                                  <CustomInput
                                    name="confirmPassword"
                                    placeholder="Confirm password"
                                    autoComplete="off"
                                    type={showConfirmPass ? "text" : "password"}
                                  />

                                  <span className="input-group-text">
                                    <span
                                      onClick={() =>
                                        setShowConfirmPass(!showConfirmPass)
                                      }
                                      className="link-secondary"
                                      title="Show password"
                                      role="button"
                                      data-bs-toggle="tooltip"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="icon"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <path
                                          stroke="none"
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                        />
                                        <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                        <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                                      </svg>
                                    </span>
                                  </span>
                                </div>
                                {props.touched.confirmPassword &&
                                  props.errors.confirmPassword && (
                                    <p className="text-danger">
                                      {props.errors.confirmPassword}
                                    </p>
                                  )}
                              </div>

                              <div className="form-footer">
                                <FormSubmitButton
                                  buttonText={"Reset Password"}
                                  width={"full"}
                                />
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
      {/* <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          /> */}
      <Footer />
    </div>
  );
};

export default UpdatePassword;
